<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
        @click.self="closePopup()">
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl md:w-[450px] w-full max-h-[90vh] overflow-hidden border border-white/20 flex flex-col"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            
            <!-- Header -->
            <div class="bg-brand text-yellow-500 py-3.5 px-5 font-bold text-[18px] flex items-center justify-between shadow-sm relative z-10">
                <div class="flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'lock']" /> Thiết lập bảo mật 2FA
                </div>
                <button @click="closePopup()" class="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white/90 hover:bg-white hover:text-brand transition-colors focus:outline-none">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>

            <!-- Body items -->
            <div class="p-6 overflow-y-auto">
                <div class="flex items-center gap-2 text-brand font-bold text-[16px] mb-3">
                    <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="text-amber-500 text-xl" /> Chú ý quan trọng:
                </div>
                
                <div class="text-[14px] text-gray-600 leading-relaxed mb-5 bg-amber-50 border border-amber-100 p-4 rounded-xl shadow-inner">
                    Sau khi xác nhận hệ thống sẽ gửi một mã QR và Khóa bí mật về. <br>
                    Vui lòng sử dụng ứng dụng <b>Google Authenticator</b> để quét hoặc dán mã, lúc này mã OTP 6 số sẽ xuất hiện trên thiết bị của bạn để dùng làm chữ ký số bảo mật.
                </div>
                
                <div class="flex flex-col items-center bg-gray-50 border border-gray-100 rounded-xl py-5 mb-2">
                    <img class="w-[80px] h-[80px] object-cover rounded-2xl shadow-sm mb-3" src="../../assets/GgAuthenticator.jpg" alt="Google Authenticator">
                    <div class="text-[13px] text-gray-500 font-medium tracking-wide">Google Authenticator</div>
                </div>
            </div>

            <!-- Footer -->
            <div class="p-5 bg-gray-50/80 border-t border-gray-100 flex items-center justify-end gap-3 rounded-b-2xl">
                <button
                    class="px-5 py-2.5 rounded-xl font-semibold border border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors shadow-sm"
                    @click="closePopup()">Hủy</button>

                <button v-if="!isload"
                    class="px-6 py-2.5 rounded-xl font-bold bg-brand text-white shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex items-center"
                    @click="setup2FA()">Tiếp tục <font-awesome-icon :icon="['fas', 'arrow-right']" class="ml-2" /></button>
                <button v-else disabled
                    class="px-6 py-2.5 rounded-xl font-bold bg-gray-400 text-white cursor-not-allowed flex items-center shadow-sm">
                    <svg class="mr-2 h-4 w-4 animate-spin" viewBox="0 0 24 24"><font-awesome-icon :icon="['fas', 'spinner']" /></svg> Đang xử lý...
                </button>
            </div>
            
        </div>
        <SetupOtpPopup v-if="isShowSetupOtpPopup" :isShow="isShowSetupOtpPopup" @closed="onClosedSetOtpPopup" :qrURL="qrURL" :secret="secret"/>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
import SetupOtpPopup from './SetupOtpPopup.vue';
export default {
    components: {
        SetupOtpPopup
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },

    },
    data() {
        return {
            isVisible: true,
            isload: false,
            isShowSetupOtpPopup: false,
            qrURL: '',
            secret: ''
        };
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        onClosedSetOtpPopup(e) {
            if(e) {
                this.closePopup()
            }
            this.isShowSetupOtpPopup = false
        },
        onOpenSetupOtpPopup() {
            this.isShowSetupOtpPopup = true
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        async setup2FA() {
            this.isload = true
            await this.$axios.put(`${API_URL}/authuserslog/setup2FA`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                if(res.data.data) {
                    this.qrURL = res.data.data?.OPTauthUrl
                    this.secret = res.data.data?.secret
                    this.onOpenSetupOtpPopup()
                } else {
                    this.$notify.error({
                        title: 'Thất bại',
                        message: 'Đã có lỗi xảy ra'
                    });
                }
                this.isload = false
            }).catch(err => {
                this.$notify.error({
                    title: 'Thất bại',
                    message: err
                });
            });

        },
    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>